"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _333Icon = createIcon({
  displayName: "_333Icon",
  viewBox: "0 0 500 500",
  path: (
    <>
      <path
        d="m29.056311 29.491526h116.05709v116.05709h-116.05709z"
        fill="currentColor"
      />
      <path
        d="m191.53624 29.491526h116.05709v116.05709h-116.05709z"
        fill="currentColor"
      />
      <path
        d="m354.01617 29.491526h116.05709v116.05709h-116.05709z"
        fill="currentColor"
      />
      <path
        d="m29.636597 191.97145h116.05709v116.05709h-116.05709z"
        fill="currentColor"
      />
      <path
        d="m192.11653 191.97145h116.05709v116.05709h-116.05709z"
        fill="currentColor"
      />
      <path
        d="m354.59647 191.97145h116.05709v116.05709h-116.05709z"
        fill="currentColor"
      />
      <path
        d="m29.926739 354.45139h116.05709v116.05709h-116.05709z"
        fill="currentColor"
      />
      <path
        d="m192.40666 354.45139h116.05709v116.05709h-116.05709z"
        fill="currentColor"
      />
      <path
        d="m354.8866 354.45139h116.05709v116.05709h-116.05709z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default _333Icon;
